import React, {useEffect, useState} from "react";
import styles from "../styles/components/EditSongForm.module.css";

const isEnabled = (value) => String(value) === "1";

const EditSongForm = ({ song, onSave, onCancel }) => {
    const [formState, setFormState] = useState({
        title: song.title || "",
        type: song.type || "contemporary",
        ccli_number: song.ccli_number || "",
        songwriter: song.songwriter || "",
        hymn_number: song.hymn_number || "",
        has_slideshow: isEnabled(song.has_slideshow) ? "1" : "0",
        notes: song.notes || "",
        is_blacklisted: isEnabled(song.is_blacklisted) ? "1" : "0",
        blacklist_reason: song.blacklist_reason || ""
    });

    useEffect(() => {
        setFormState({
            title: song?.title || "",
            type: song?.type || "contemporary",
            ccli_number: song?.ccli_number || "",
            songwriter: song?.songwriter || "",
            hymn_number: song?.hymn_number || "",
            has_slideshow: isEnabled(song?.has_slideshow) ? "1" : "0",
            notes: song?.notes || "",
            is_blacklisted: isEnabled(song?.is_blacklisted) ? "1" : "0",
            blacklist_reason: song?.blacklist_reason || ""
        });
    }, [song]);

    const handleChange = (e) => {
        const { name, checked, value } = e.target;
        if(name === "is_blacklisted") {
            setFormState((prev) => ({
                ...prev,
                is_blacklisted: checked ? "1" : "0",
                blacklist_reason: checked ? prev.blacklist_reason : ""
            }));
            return;
        }

        setFormState((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSave({ ...song, ...formState });
    };

    return (
        <form className={styles.form} onSubmit={handleSubmit}>
            <h3>Edit Song</h3>
            <label>
                Title:
                <input name="title" value={formState.title} onChange={handleChange} required />
            </label>

            <label>
                Type:
                <select name="type" value={formState.type} onChange={handleChange}>
                    <option value="contemporary">Contemporary</option>
                    <option value="hymn">Hymn</option>
                </select>
            </label>

            <label>
                CCLI Number:
                <input name="ccli_number" value={formState.ccli_number} onChange={handleChange} />
            </label>

            <label>
                Songwriter(s):
                <input name="songwriter" value={formState.songwriter} onChange={handleChange} />
            </label>

            <label>
                Hymn Number:
                <input name="hymn_number" value={formState.hymn_number} onChange={handleChange} />
            </label>

            <label>
                Slideshow:
                <select name="has_slideshow" value={formState.has_slideshow} onChange={handleChange}>
                    <option value="">Not Specified</option>
                    <option value="1">Yes</option>
                    <option value="0">No</option>
                </select>
            </label>

            <label>
                Notes:
                <textarea name="notes" value={formState.notes} onChange={handleChange} />
            </label>

            <label className={styles.checkboxLabel}>
                <input
                    type="checkbox"
                    name="is_blacklisted"
                    checked={formState.is_blacklisted === "1"}
                    onChange={handleChange}
                />
                Blacklisted
            </label>

            {formState.is_blacklisted === "1" && (
                <label>
                    Blacklist Reason:
                    <textarea
                        name="blacklist_reason"
                        value={formState.blacklist_reason}
                        onChange={handleChange}
                    />
                </label>
            )}

            <div className={styles.buttonRow}>
                <button type="submit">Save</button>
                <button type="button" onClick={onCancel}>Cancel</button>
            </div>
        </form>
    );
};

export default EditSongForm;
